import { encodeBase64 } from "./utils";

export const SignInWithAzure = (cupixWorksApiEndpoint: string, teamDomain: string) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${cupixWorksApiEndpoint}/auth/azure_activedirectory_v2`;

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "team_domain";
  input.value = teamDomain;

  form.appendChild(input)
  document.body.appendChild(form);

  form.submit();
};

export const CupixWorksDomain = (teamDomain = "app", region = "us") => {
  const postfixRegion = region.toLowerCase() === "us" ? "" : `-${region.toLowerCase()}`;
  return `https://${teamDomain}.cupix${postfixRegion}.works`;
}

export const CupixWorksDomainPostfix = (cupixworksApiEndpoint: string | undefined) => {
  try {
    if (!cupixworksApiEndpoint) {
      throw new Error("cupixworksApiEndpoint is undefined.");
    }

    const splited = cupixworksApiEndpoint.split(".");
    if (splited.length < 3) {
      throw new Error("cupixworksApiEndpoint is invalid.");
    }

    return `.${splited.slice(1).join(".")}`;
  } catch (e) {
    console.warn("Failed to parse cupixworksApiEndpoint to get domain postfix: ", e);
    return ".cupix.works";
  }
}

export const convertOAuthToWardenConfig = (searchParams: URLSearchParams) => {
  const clientId = searchParams.get("client_id");
  const redirectUri = searchParams.get("redirect_uri");
  const region = searchParams.get("region") || 'us';
  const teamDomain = searchParams.get("team_domain");

  // NOTE: these params are not used but OAuth2 standard
  // const scope = searchParams.get("scope"); // no spec
  // const responseType = searchParams.get("response_type"); // acts like a 'token' due to implicit flow

  if (!clientId || !redirectUri || !region || !teamDomain) {
    return undefined;
  }

  return encodeBase64([
    {
      client_id: clientId,
      redirect_uri: redirectUri,
      region_display: region,
      cupixworks_api_endpoint: CupixWorksDomain(teamDomain ?? 'app', region),
    }
  ]);
}